

function checkURL() {



  const kyp = document.querySelectorAll('.paragraph--type--kyp-subscription');
  kyp.forEach((parent) => {


    // On cherche la div interne avec la classe spécifique
    const adviseSubDiv = parent.querySelector('.field--name-field-advise-sub');

    // Si on trouve la div, on récupère sa valeur
    if (adviseSubDiv) {
      const value = adviseSubDiv.textContent.trim();
      if(value === "On"){
        console.log(value);
        const card__suptitle = document.createElement('div');
        card__suptitle.classList.add('card__suptitle');
        const divCible = parent.querySelector('.field--name-field-title');

        divCible.parentNode.insertBefore(card__suptitle, divCible);

      }



    }

  });

  const card__suptitle = document.querySelectorAll('.card__suptitle');
  card__suptitle.forEach((parent) => {

    const cardSupTitletext = document.createElement('div');
    cardSupTitletext.classList.add('card__suptitle-text');

    parent.appendChild(cardSupTitletext);


    const supText = parent.querySelector('.card__suptitle-text');

    supText.innerHTML = "On vous recommande cet abonnement KYP"

  });

  const priceDivsWE = document.querySelectorAll('.field--name-field-price-without-engagement');
  const processedValuesWE = [];

  priceDivsWE.forEach((parent) => {
    const value = parent.textContent.trim();

    if (value === '0') {
      parent.style.display = 'none';

    }else{

      processedValuesWE.push(value); // Ajoute la valeur au tableau

      parent.innerHTML = "";

    }




    const cardPrice = document.createElement('div');
    const cardSubPrice = document.createElement('div');
    cardPrice.classList.add('card__price');
    cardSubPrice.classList.add('card__subprice')
    parent.appendChild(cardPrice);
    parent.appendChild(cardSubPrice);
  });

  const priceDivsE = document.querySelectorAll('.field--name-field-price-with-engagement');
  const processedValuesE = [];

  priceDivsE.forEach((parent) => {
    const value = parent.textContent.trim();

    if (value === '0') {
      parent.style.display = 'none';

    }else{

      processedValuesE.push(value); // Ajoute la valeur au tableau

      parent.innerHTML = "";

    }




    const cardPrice = document.createElement('div');
    const cardSubPrice = document.createElement('div');
    cardPrice.classList.add('card__price');
    cardSubPrice.classList.add('card__subprice')
    parent.appendChild(cardPrice);
    parent.appendChild(cardSubPrice);
  });

  const cardPrice = document.querySelectorAll('.card__price');
  cardPrice.forEach((parent) => {
    const span = document.createElement('span');
    const sup = document.createElement('sup');
    span.classList.add('card__price-value');
    span.classList.add('monthly')
    sup.classList.add('card__price-currency');

    parent.appendChild(span);
    parent.appendChild(sup);
  });


  const subprice = document.querySelectorAll('.field--name-field-price-without-engagement > .card__subprice');
  subprice.forEach((parent) => {
    const span1 = document.createElement('span');
    const span2 = document.createElement('span');
    span1.classList.add('card__subprice-value');
    span1.classList.add('monthly')
    span2.classList.add('card__subprice-currency');

    parent.appendChild(span1);
    parent.appendChild(span2);

  });

  const subpriceWE = document.querySelectorAll('.field--name-field-price-with-engagement > .card__subprice');
  subpriceWE.forEach((parent) => {
    const span1 = document.createElement('span');
    const span2 = document.createElement('span');
    span1.classList.add('card__subprice-value');
    span1.classList.add('monthly')
    span2.classList.add('card__subprice-currency');

    parent.appendChild(span1);
    parent.appendChild(span2);

  });

  const monthly = document.querySelectorAll('.field--name-field-price-without-engagement > .card__price > .card__price-value');
  monthly.forEach((parent, index) => {
    parent.innerHTML = processedValuesWE[index];
  });

  const monthlyWE = document.querySelectorAll('.field--name-field-price-with-engagement > .card__price > .card__price-value');
  monthlyWE.forEach((parent, index) => {
    parent.innerHTML = processedValuesE[index];
  });


  const monthlyTTC = document.querySelectorAll('.field--name-field-price-without-engagement > .card__subprice > .card__subprice-value');
  monthlyTTC.forEach((parent, index) => {
    const ttc = processedValuesWE[index] * 1.2;
    parent.innerHTML = ttc;
  });

  const monthlyTTCWE = document.querySelectorAll('.field--name-field-price-with-engagement > .card__subprice > .card__subprice-value');
  monthlyTTCWE.forEach((parent, index) => {
    const ttc = processedValuesE[index] * 1.2;
    parent.innerHTML = ttc;
  });
  const monthlyHT = document.querySelectorAll('.field--name-field-price-without-engagement > .card__price > .card__price-currency');
  monthlyHT.forEach((parent) => {
    parent.innerHTML = " € HT";
  });
  const monthlyHTWE = document.querySelectorAll('.field--name-field-price-with-engagement > .card__price > .card__price-currency');
  monthlyHTWE.forEach((parent) => {
    parent.innerHTML = " € HT";
  });
  const monthlyETTC = document.querySelectorAll('.field--name-field-price-without-engagement > .card__subprice > .card__subprice-currency');
  monthlyETTC.forEach((parent) => {
    parent.innerHTML = " € TTC";
  });
  const monthlyETTCWE = document.querySelectorAll('.field--name-field-price-with-engagement > .card__subprice > .card__subprice-currency');
  monthlyETTCWE.forEach((parent) => {
    parent.innerHTML = " € TTC";
  });

}

// Exécuter la fonction uniquement lors du chargement de la page
document.addEventListener('DOMContentLoaded', checkURL);
